module.exports = __webpack_public_path__ + "img/tip.c2ae31c6.png";